import React from 'react';
import { DashboardData, CalculatedData } from '../types';

interface MetricsCardsProps {
  data: DashboardData;
  calculatedData: CalculatedData;
}

const MetricsCards: React.FC<MetricsCardsProps> = ({
  data,
  calculatedData,
}) => {
  // 難易度に応じた日本語表示
  const getDifficultyLabel = (difficulty: string): string => {
    switch (difficulty) {
      case 'EASY':
        return '容易';
      case 'NORMAL':
        return '標準的';
      case 'HARD':
        return '困難';
      case 'VERY HARD':
        return '非常に困難';
      case 'EXTREME':
        return '極めて困難';
      default:
        return '標準的';
    }
  };

  return (
    <>
      {/* メイン指標（二段構成） */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {/* 上段 */}
        <div className="metric-card p-6 text-center">
          <h3 className="text-sm text-gray-600 mb-1">実効就活母集団率</h3>
          <div className="text-3xl font-bold text-blue-600">
            {data.effectiveJobSeekingRate.toFixed(1)}%
          </div>
          <div className="text-xs text-gray-500">自動算出</div>
        </div>
        <div className="metric-card p-6 text-center">
          <h3 className="text-sm text-gray-600 mb-1">最終採用倍率</h3>
          <div className="text-3xl font-bold text-red-600">
            {calculatedData.finalRatio.toFixed(1)}倍
          </div>
          <div className="text-xs text-gray-500">
            {getDifficultyLabel(calculatedData.difficulty)}
          </div>
        </div>
        <div
          className={`metric-card p-6 text-center ${calculatedData.difficultyClass}`}
        >
          <h3 className="text-sm mb-1 opacity-90">採用難易度</h3>
          <div className="text-2xl font-bold">{calculatedData.difficulty}</div>
          <div className="text-xs opacity-75">リアルタイム判定</div>
        </div>
      </div>

      {/* 下段 */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="metric-card p-6 text-center">
          <h3 className="text-sm text-gray-600 mb-1">必要応募者数</h3>
          <div className="text-3xl font-bold text-purple-600">
            {calculatedData.requiredApplicants.toLocaleString()}人
          </div>
        </div>
        <div className="metric-card p-6 text-center">
          <h3 className="text-sm text-gray-600 mb-1">採用単価</h3>
          <div className="text-3xl font-bold text-green-600">
            {calculatedData.costPerHire.toFixed(1)}万円
          </div>
        </div>
      </div>
    </>
  );
};

export default MetricsCards;
